import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-xl border border-[#E4E8EF] bg-[#F1F5FA] px-3 py-1 text-base text-[#0B1620] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[#0B1620] placeholder:text-[#5B6675]/70 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#0B4F3F] focus-visible:border-[#0B4F3F]/60 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
